const triggers = {
  bindings: {
  },
  templateUrl: '/modules/pis-tool/triggers/triggers.html',
  controller: 'TriggersController',
};

angular
  .module('pis-tool.module')
  .component('triggers', triggers)
  .config(function($stateProvider) {
      $stateProvider.state('pis.workspaces.streamcollections', {
          url: '/streamcollections',
          views: {
              'pisview@pis': 'triggers',
          },
          resolve: {
              // workSpaces: PISService => PISService.getAllWorkspaces(),
          },
      });
  });
